import { render, staticRenderFns } from "./ClientTopbar.vue?vue&type=template&id=ab40b0f0&scoped=true&"
import script from "./ClientTopbar.vue?vue&type=script&lang=js&"
export * from "./ClientTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab40b0f0",
  null
  
)

export default component.exports